import { Link2, Copy, Loader2, Trash2 } from "lucide-react";

/**
 * Re-usable share-link panel.
 * Both seed-pack and bid-pack share UIs render through this component.
 */
export default function SharePanel({
  kind,
  title,
  desc,
  state,
  onCreate,
  onCopy,
  onRevoke,
  testid,
  accentClass,
}) {
  return (
    <div className="bg-white border border-gray-300 p-5" data-testid={`${testid}-panel`}>
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <div className="flex items-center gap-2">
            <Link2 size={16} className="text-[#FF6B00]" />
            <p className="text-[10px] font-bold uppercase tracking-[0.1em] text-gray-500">
              {kind === "bid" ? "Public Bid-Pack Link" : "Public Share Link"}
            </p>
          </div>
          <h3 className="font-heading text-lg tracking-tight font-bold text-black">{title}</h3>
          <p className="text-sm text-gray-600 mt-1 max-w-2xl">{desc}</p>
        </div>
        <button
          onClick={onCreate}
          disabled={state.uploading}
          data-testid={`${testid}-btn`}
          className={`${accentClass} text-white rounded-none px-4 py-2.5 font-bold text-sm inline-flex items-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed`}
        >
          {state.uploading
            ? <><Loader2 size={14} className="animate-spin" /> Creating…</>
            : <><Link2 size={14} /> Create share link</>}
        </button>
      </div>

      {state.link && (
        <div className="mt-5 border-t border-gray-200 pt-4 space-y-3" data-testid={`${testid}-result`}>
          <div className="flex items-center gap-2">
            <input
              readOnly
              value={state.link}
              onFocus={(e) => e.target.select()}
              data-testid={`${testid}-url`}
              className="border border-gray-300 rounded-none px-2 py-1.5 font-mono text-xs w-full bg-gray-50"
            />
            <button
              onClick={onCopy}
              data-testid={`${testid}-copy-btn`}
              className="bg-white border border-gray-300 hover:bg-gray-100 rounded-none px-3 py-1.5 font-bold text-xs inline-flex items-center gap-1"
              title="Copy link"
            >
              <Copy size={12} /> Copy
            </button>
            <a
              href={state.link}
              target="_blank" rel="noreferrer"
              data-testid={`${testid}-open-link`}
              className="bg-black text-white hover:bg-[#002FA7] rounded-none px-3 py-1.5 font-bold text-xs inline-flex items-center gap-1"
            >
              Open
            </a>
            <button
              onClick={onRevoke}
              data-testid={`${testid}-revoke-btn`}
              className="bg-white border border-gray-300 hover:bg-red-50 hover:border-[#FF2400] hover:text-[#FF2400] rounded-none px-3 py-1.5 font-bold text-xs inline-flex items-center gap-1"
              title="Revoke this link"
            >
              <Trash2 size={12} /> Revoke
            </button>
          </div>
          <p className="text-[10px] font-mono uppercase tracking-wider text-gray-500" data-testid={`${testid}-meta`}>
            {state.filename} · {(state.size / 1024).toFixed(1)} KB
          </p>
        </div>
      )}
    </div>
  );
}
